<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard>
        <CCardBody>
      <form
      @submit="saveData"
      method="post"
      >
          <h3 v-if="isEditing">
            {{ $t('button.edit') }} {{ $tc('drivers.label', 1) }}
          </h3>
          <h3 v-else>{{ $t('button.create') }} {{ $tc('drivers.label', 1) }}</h3>
          <div class="row">
            <div class="col-6">
              <CInput :label="$t('fields.name')" type="text" placeholder="Ex: Juan Perez" v-model="driver.name" required></CInput> 
            </div>
            <div class="col-6">
              <CInput :label="$t('fields.username')" type="text" placeholder="Ex: username" v-model="driver.username" required></CInput> 
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <CInput :label="$t('fields.password')" type="password" placeholder="" v-model="driver.password" required></CInput> 
            </div>
            <div class="col-6">
              <CInput :label="$t('fields.password_confirmation')" type="password" placeholder="" v-model="driver.password_confirmation" required></CInput> 
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <CInput :label="$t('fields.personal_id')" type="text" placeholder="Ex: 0000000000" v-model="driver.personal_id" required></CInput> 
            </div>
            <div class="col-6">
              <CInput :label="$t('fields.license_id')" type="text" placeholder="Ex: username" v-model="driver.license_id" required></CInput> 
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <CSelect
                :label="$t('fields.payment_type')" 
                :value.sync="driver.payment_type"
                :plain="true"
                :options="payment_types"
                :placeholder="$t('fields.payment_type_placeholder')"
                required
              >
              </CSelect>
            </div>
            <div class="col-6">
              <CInput :label="$t('fields.salary')" prepend="$" type="text" placeholder="Ex: 1000" v-model="driver.salary" required></CInput>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <CSelect
                :label="$t('fields.is_active')" 
                :value.sync="driver.status"
                :plain="true"
                :options="statuses"
                :placeholder="$t('fields.status_placeholder')"
                required
              >
              </CSelect>
            </div>
          </div>
          <CButton color="success" type="submit">
              <template v-if="isEditing"> {{ $t('button.update') }}</template>
              <template v-else> {{ $t('button.create') }}</template>
          </CButton>
          <CButton color="primary" @click="goBack">{{ $t('button.back') }}</CButton>
          </form>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import formMixin from '../../mixins/form';
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";

export default {
  name: 'FormDriver',
  mixins: [formMixin, localeMixin],
  data() {
    return {
        driver: {
          name: '',
          social_id: '',
          username: '',
          password: '',
          password_confirmation: '',
          personal_id: '',
          payment_type: '',
          salary: '',
          status: ''
        },
        payment_types: [
          {
            label: 'Fixed',
            value: "fixed"
          },
          {
            label: 'Per Bottles',
            value: "bottles"
          }
        ],
        statuses: [
          {
            label: i18n.t('fields.active'),
            value: "1"
          },
          {
            label: i18n.t('fields.inactive'),
            value: "0"
          }
        ]
    }
  },
  mounted() {
    if (this.isEditing) {
      this.getDriver();
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.permissions,
    }),
    driverId() {
      return this.$route.params.id;
    }
  },
  methods: {
      showAlertError() {
          if (this.message != "") {
              this.$swal({
                  title: i18n.t('modal.title'),
                  text: this.message,
                  icon: 'warning',
                  showCancelButton: true,
                  cancelButtonColor: '#d33',
              });
          } else {
              this.$swal({
                  title: i18n.t('modal.title'),
                  text: i18n.t('modal.body'),
                  icon: 'warning',
                  showCancelButton: true,
                  cancelButtonColor: '#d33',
              });
          }
      },
    goBack() {
      this.$router.push({ name: 'Drivers' });
    },
    showAlert(type, msg) {
      let title = '';
      let body = '';
      let status = '';
      let redirect = true;

      switch(type) {
        case 'add':
          title = i18n.t('drivers.modal.created_label');
          body = i18n.t('drivers.modal.created_body');
          status = 'success';
          break;
        case 'edit':
          title = i18n.t('drivers.modal.updated_label');
          body = i18n.t('drivers.modal.updated_body');
          status = 'success';
          break;
        case 'error':
          title = 'Error';
          body = msg;
          status = 'danger';
          redirect = false;
          break;
      }

      this.$swal(
        title,
        body,
        status
      ).then(result => {
        if (redirect) {
          this.goBack();
        }
      });
    },
    saveData(e) {
        e.preventDefault();
        const data = this.driver;
        this.$emit("saved", data);
        let url = `/api/drivers`;
        let sendRequest = null;

        if (this.isEditing) {
            url = url + "/" + this.driverId + '?token=' + localStorage.getItem("api_token");
            sendRequest = async() => {
                try {
                    const response = await axios.put(url, data);
                    if (response.data.status === "success") {
                        this.showAlert('edit');
                    }
                } catch (error) {
                    if(error.response.data.message == 'The given data was invalid.') {
                        this.message = '';
                        for (let key in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(key)) {
                                this.message += error.response.data.errors[key][0] + '  ';
                            }
                        }
                        this.showAlert('error', this.message);
                    } else{
                        console.log(error);
                        this.showAlertError(); 
                    }
                }
            };
        } else {
            url = url + '?token=' + localStorage.getItem("api_token");
            sendRequest = async() => {
                try {
                    const response = await axios.post(url, data);
                    if (response.data.status === "success") {
                        for (const key in data) {
                            data[key] = "";
                        }
                        this.message = 'Successfully created expense.';
                        this.showAlert('add');
                    }
                    // console.log(response.data);
                } catch (error) {
                    if(error.response.data.message == 'The given data was invalid.'){
                        this.message = '';
                        for (let key in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(key)) {
                                this.message += error.response.data.errors[key][0] + '  ';
                            }
                        }
                        this.showAlert('error', this.message);
                    } else{
                        console.log(error);
                        this.showAlertError(); 
                    }
                }
            };
        }
        sendRequest();
        return data;
    },
    getDriver() {
        axios.get('/api/drivers/' + this.driverId + '?token=' + localStorage.getItem("api_token"))
        .then(response => {
            this.driver = response.data;
            this.driver.status_class = this.driver.status ? "primary" : "secondary";
        }).catch(error => {
            console.log(error);
            this.showAlertError(); 
        });
    }
  }
}

</script>
